'use client';
import React, { useState } from 'react';
import { Toaster } from 'sonner';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import AuthBrandPanel from './AuthBrandPanel';

export type AuthMode = 'login' | 'signup' | 'forgot';

export default function AuthScreen() {
  const [mode, setMode] = useState<AuthMode>('login');

  return (
    <div className="min-h-screen flex bg-background">
      <Toaster position="bottom-right" richColors />
      {/* Brand panel — hidden on mobile */}
      <AuthBrandPanel />

      {/* Form panel */}
      <div className="flex-1 flex items-center justify-center px-6 py-12 min-h-screen">
        <div className="w-full max-w-md">
          {mode === 'login' && <LoginForm onSwitch={setMode} />}
          {mode === 'signup' && <SignUpForm onSwitch={setMode} />}
          {mode === 'forgot' && <ForgotPasswordForm onSwitch={setMode} />}
        </div>
      </div>
    </div>
  );
}